import React from "react";
import FacilityProfileChartPlaceholder from "../../shared/placeholders/FacilityProfileChartPlaceholder";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export default function FacilityManifestsPerYearChart(props) {
  const onBtPrinterFriendly = () => {
    var container = document.getElementById("facility-manifest-chart-container");
    if (container) container.style.width = "50%";
  };

  const onBtNormal = () => {
    var container = document.getElementById("facility-manifest-chart-container");
    if (container) container.style.width = "100%";
  };

  window.addEventListener("beforeprint", () => onBtPrinterFriendly());
  window.addEventListener("afterprint", () => onBtNormal());

  if (props.data.length < 1) {
    return <FacilityProfileChartPlaceholder />;
  } else {
    return (
      <div>
        <div className="facility-manifest-chart-title">
          Manifest Per Year by Handler Type
          </div>
        <div className="facility-manifest-chart">
          <ResponsiveContainer id="facility-manifest-chart-container" width="100%" height={300}>
            <LineChart
              data={props.data}
              margin={{ top: 20, right: 0, left: 0, bottom: 20 }}
            >
              <XAxis dataKey="SHIP_YEAR" angle={-45} textAnchor="end" />
              <YAxis />
              <CartesianGrid stroke="#f5f5f5" />
              <Line
                type="monotone"
                dataKey="GEN_COUNTS"
                name="Generator"
                stroke="#8884d8"
                dot={false}
              />
              <Line
                type="monotone"
                dataKey="TRANS_COUNTS"
                name="Transporter"
                stroke="#413ea0"
                dot={false}
              />
              <Line
                type="monotone"
                dataKey="TSDF_COUNTS"
                name="TSDF"
                stroke="#ff7300"
                dot={false}
              />
              <Tooltip />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}
